import React, { useState, useEffect, useContext } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import "./Header.css"; // Import your custom CSS file
import { AuthContext } from "../context/AuthProvider";
import axios from "axios";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isTop, setIsTop] = useState(true); // State to track if scrolled to top
  const { auth, logout } = useContext(AuthContext); // Access auth and logout from context
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/headerServices/activeServices`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching the services data:", error);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    // Function to handle scroll event
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Check if scrolled to top
      setIsTop(scrollPosition === 0);
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove event listener
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  // Generate menu items from filtered services data
  const menuItems = services.map((service) => ({
    href: service.targetUrl,
    className: service.iconName,
    text: service.serviceName,
    onClick: service.serviceName === "Logout" ? logout : undefined,
  }));

  return (
    <Navbar
      className={`navbar-transparent sticky-top${isTop ? "" : " top-scroll"}`}
      expand="md"
    >
      <NavbarBrand href="/" className="d-flex text-light">
        <b>RC.</b>
      </NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar className="justify-content-center">
        <Nav className="ms-auto" navbar>
          {menuItems.map((item, index) => (
            <NavItem key={index}>
              <NavLink
                href={item.href}
                className="nav-link"
                onClick={item.onClick}
              >
                <i className={`fas ${item.className} icon`} />
                <span className="nav-text">{item.text}</span>
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default Header;
